export default "__VITE_ASSET__BggcUiIZ__"